import del from './methodDelete';
import get from './methodGet';
import patch from './methodPatch';
import post from './methodPost';

export default { ...del, ...get, ...patch, ...post };
